import { create } from "zustand";

export const useAgentStore = create((set, get) => ({
  selectedAgent: null,
  agents: [],

  setSelectedAgent: (agent) =>
    set((state) => ({
      selectedAgent:
        typeof agent === "function"
          ? agent(state.selectedAgent) // ✅ call function with previous state
          : agent,                     // ✅ normal value
    })),

  setAgents: (agents) => set({ agents }),

  clearSelectedAgent: () => set({ selectedAgent: null }),

  updateSelectedAgentMetaAds: (meta_ads) =>
    set((state) =>
      state.selectedAgent
        ? { selectedAgent: { ...state.selectedAgent, meta_ads } }
        : {}
    ),

  updateSelectedAgentTelephone: (telephone) =>
    set((state) => {
      if (!state.selectedAgent || !telephone) return {};
      return {
        selectedAgent: {
          ...state.selectedAgent,
          meta: {
            ...(state.selectedAgent.meta || {}),
            telephone,
          },
        },
      };
    }),

  updateSelectedAgentWhatsapp: (whatsappPatch) =>
    set((state) => {
      if (!state.selectedAgent || !whatsappPatch) return {};
      const current = state.selectedAgent.whatsapp || { numbers: [] };
      return {
        selectedAgent: {
          ...state.selectedAgent,
          whatsapp: {
            ...current,
            ...whatsappPatch,
            numbers: whatsappPatch.numbers ?? current.numbers ?? [],
          },
        },
      };
    }),

  getSelectedAgentProperties: () => {
    const { selectedAgent, agents } = get();
    if (!selectedAgent) return [];

    const agent = agents.find((a) => a.id === selectedAgent.id);
    return agent?.properties || [];
  },
}));
